export default __webpack_public_path__ + "static/media/Nitroxgallery_1.751447d7.jpg";